"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _desc, _value, _class;

var _templateObject = (0, _taggedTemplateLiteral3.default)([""], [""]),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n\tposition: relative;\n\tcursor: pointer;\n\tpadding-left: ", "em;\n\tmargin-bottom: ", "em;\n\n\t&:hover {\n\t\topacity: 0.7;\n\t}\n\n\t&:before {\n\t\tmargin-top: 3px;\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tborder: ", "em solid transparent;\n\t\tborder-top-width: ", "em;\n\t\tborder-bottom-width: 0;\n\t\tborder-top-color: ", ";\n\t\theight: ", "em;\n\t\twidth: ", "em;\n\t\ttransform: rotate(", ");\n\t}\n"], ["\n\tposition: relative;\n\tcursor: pointer;\n\tpadding-left: ", "em;\n\tmargin-bottom: ", "em;\n\n\t&:hover {\n\t\topacity: 0.7;\n\t}\n\n\t&:before {\n\t\tmargin-top: 3px;\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tborder: ", "em solid transparent;\n\t\tborder-top-width: ", "em;\n\t\tborder-bottom-width: 0;\n\t\tborder-top-color: ", ";\n\t\theight: ", "em;\n\t\twidth: ", "em;\n\t\ttransform: rotate(", ");\n\t}\n"]),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(["\n\tbackground: ", ";\n\tborder-radius: ", ";\n\tborder: 1px solid ", ";\n\tdisplay: ", ";\n\tpadding: ", ";\n\n\t&.scrolled {\n\t\tbox-shadow: none;\n\t}\n"], ["\n\tbackground: ", ";\n\tborder-radius: ", ";\n\tborder: 1px solid ", ";\n\tdisplay: ", ";\n\tpadding: ", ";\n\n\t&.scrolled {\n\t\tbox-shadow: none;\n\t}\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _autobindDecorator = require("autobind-decorator");

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _getters = require("../getters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

// --------------------------------------------------

var getHalfArrowWidth = _ramda2.default.pipe(_getters.getArrowWidth, _ramda2.default.multiply(0.5));

// --------------------------------------------------

var Wrapper = _styledComponents2.default.div(_templateObject);

var Trigger = _styledComponents2.default.div(_templateObject2, _getters.getPaddingHorizontal, _getters.getPaddingVertical, getHalfArrowWidth, _getters.getArrowWidth, (0, _getters.getColor)("darkgray"), _getters.getArrowWidth, _getters.getArrowWidth, function (props) {
	return props.active ? "0deg" : "-90deg";
});

var Content = _styledComponents2.default.div(_templateObject3, (0, _getters.getColor)("lightgray"), _getters.getBorderRadius, (0, _getters.getColor)("gray"), function (props) {
	return props.active ? "block" : "none";
}, _getters.getPadding2);

// --------------------------------------------------

var Collapsable = (_class = function (_React$Component) {
	(0, _inherits3.default)(Collapsable, _React$Component);

	function Collapsable(props) {
		(0, _classCallCheck3.default)(this, Collapsable);

		var _this = (0, _possibleConstructorReturn3.default)(this, (Collapsable.__proto__ || Object.getPrototypeOf(Collapsable)).call(this, props));

		_this.state = {
			active: false
		};
		return _this;
	}

	(0, _createClass3.default)(Collapsable, [{
		key: "toggle",
		value: function toggle() {
			this.setState(function (pState) {
				return { active: !pState.active };
			});
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(
				Wrapper,
				null,
				_react2.default.createElement(
					Trigger,
					(0, _extends3.default)({ onClick: this.toggle }, this.state),
					this.props.label ? this.props.label : "Collapsed Content"
				),
				_react2.default.createElement(
					Content,
					this.state,
					this.props.children
				)
			);
		}
	}]);
	return Collapsable;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, "toggle", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, "toggle"), _class.prototype)), _class);

// --------------------------------------------------

exports.default = Collapsable;

//# sourceMappingURL=collapsable.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/collapsable.js
// module id = 370
// module chunks = 0